import { render } from "./Pendings.vue?vue&type=template&id=50cc4858&scoped=true"
import script from "./Pendings.vue?vue&type=script&lang=js"
export * from "./Pendings.vue?vue&type=script&lang=js"

import "./Pendings.vue?vue&type=style&index=0&id=50cc4858&scoped=true&lang=scss"
import "./Pendings.vue?vue&type=style&index=1&id=50cc4858&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cc4858"]])

export default __exports__